import * as React from 'react';

import * as styles from './ChatbotButtonsLayout.css';

interface IChatbotButtonsLayoutProps {
  children: React.ReactNode;
}

export const ChatbotButtonsLayout: React.FC<IChatbotButtonsLayoutProps> = ({ children }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['inner-container']}>{children}</div>
    </div>
  );
};
